import { Box, Flex, Picture, Typography } from "@jewlr/storybook/core"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"

const bannerData = {
  alt: "",
  fallback:
    "https://cms.jewlr.com/sparkle_with_confidence_2x_7940159b4a/sparkle_with_confidence_2x_7940159b4a.jpg",
  srcSet: [
    {
      height: 600,
      media: "(max-width: 767px)",
      sizes: "100vw",
      srcSet: getImgSrcSet(
        `${sl.config.jewlr_imgsmbly_url}cms/m_sparkle_with_confidence_2x_c95b244c83/m_sparkle_with_confidence_2x_c95b244c83.jpg`,
        686
      ),
      width: 686,
    },
    {
      height: 872,
      media: "(min-width: 768px) and (max-width: 1279px)",
      sizes: "50vw",
      srcSet: getImgSrcSet(
        `${sl.config.jewlr_imgsmbly_url}cms/sparkle_with_confidence_3664e153a0/sparkle_with_confidence_3664e153a0.jpg`,
        864
      ),
      width: 864,
    },
    {
      height: 1000,
      media: "(min-width: 1280px)",
      sizes: "(max-width: 1920px) 50vw, 880px",
      srcSet: getImgSrcSet(
        `${sl.config.jewlr_imgsmbly_url}cms/sparkle_with_confidence_2x_7940159b4a/sparkle_with_confidence_2x_7940159b4a.jpg`,
        1760
      ),
      width: 1760,
    },
  ],
}

const SparkleWithConfidence = () => {
  return (
    <>
      <Helmet>
        {bannerData.srcSet.map((srcset) => (
          <link
            as="image"
            /* eslint-disable react/no-unknown-property */
            fetchpriority="high"
            imagesizes={srcset.sizes}
            imagesrcset={srcset.srcSet}
            key={srcset.media}
            media={srcset.media}
            rel="preload"
          />
        ))}
      </Helmet>
      <Flex
        alignItems="center"
        containWide
        flexDirection={{ _: "column", tablet: "row" }}
        gap={{ _: "20px", desktop: 5 }}
        mb={{ _: 4, desktop: "60px" }}
      >
        <Box flex="1">
          <Typography className="nowrap" mb="20px" variant="h2">
            Sparkle with Confidence &ndash; <wbr />
            You&apos;re Covered!
          </Typography>
          <Typography mb="20px" variant="body">
            At Jewlr, we take pride in crafting high-quality{" "}
            {jewlr_t("jewelry")} made to last. Our warranty includes{" "}
            <b>one year of coverage</b> on all our {jewlr_t("jewelry")}, and our{" "}
            <b>Luxury Bridal Collection</b> diamond engagement rings offers a{" "}
            <b>lifetime warranty</b>. Whether shopping for yourself or a loved
            one, feel confident with your purchase, knowing you&apos;re covered.
          </Typography>

          <Typography variant="body">
            If you need assistance, please use our{" "}
            <Button asChild underline>
              <Link to="/order/repair">Request Repair Form</Link>
            </Button>
            , or contact our customer service team at{" "}
            <Button asChild underline>
              <a
                href={`tel::${sl.config.customer_service_toll_free}`}
                rel="nofollow"
              >
                {sl.config.customer_service_toll_free}
              </a>
            </Button>{" "}
            or{" "}
            <Button asChild underline>
              <a
                href={`mailto:${sl.config.customer_service_email}`}
                rel="nofollow"
              >
                {sl.config.customer_service_email}
              </a>
            </Button>{" "}
            with your order number.
          </Typography>
        </Box>
        <Box flex="1">
          <Picture {...bannerData} />
        </Box>
      </Flex>
    </>
  )
}

export default SparkleWithConfidence
